import { render, staticRenderFns } from "./MultiAcctTypeHelpList.vue?vue&type=template&id=4550c228&"
import script from "./MultiAcctTypeHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiAcctTypeHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports